import { FC, useState } from 'react'

import styled from 'styled-components'

import { MetaAdsCampaignDetails } from 'src/Redux/metaAdsDetailsApi'
import ArrowTotalBtnDown from 'src/Assets/Svg/arrowTotalDown.svg?react'

import { SettingsItem } from './SettingsItem'

const SettingsButton = styled.button<{ $isOpen: boolean }>`
  display: flex;
  width: 100%;
  height: 32px;
  color: ${({ theme }) => theme.color.darkGrey};
  padding: 0 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background: ${({ theme, $isOpen }) =>
    $isOpen ? theme.color.hoverWhite : theme.color.white};
`

const Container = styled.div`
  display: flex;
  padding-top: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`
export const StyledArrowTotalBtnDown = styled(ArrowTotalBtnDown)<{
  $active?: boolean
}>`
  transform: rotate(${(props) => (props.$active ? '180deg' : '0deg')});
  transition: transform 0.5s ease-in-out;
`

type Props = Pick<
  MetaAdsCampaignDetails,
  'countries' | 'genres' | 'similarArtistNames' | 'languages'
>

export const AdsSettings: FC<Props> = (props) => {
  const { countries, genres, similarArtistNames, languages } = props
  const [showSettings, setShowSettings] = useState(false)

  return (
    <>
      <SettingsButton
        $isOpen={showSettings}
        onClick={() => setShowSettings(!showSettings)}
      >
        <StyledArrowTotalBtnDown $active={showSettings} />
        Show campaign settings
      </SettingsButton>
      {showSettings && (
        <Container>
          {Boolean(genres?.length) && (
            <SettingsItem title='Genres' description={genres?.join(', ')} />
          )}
          {Boolean(languages?.length) && (
            <SettingsItem
              title={
                languages && languages.length > 1 ? 'Language(s)' : 'Language'
              }
              description={languages?.join(', ')}
            />
          )}
          {Boolean(similarArtistNames?.length) && (
            <SettingsItem
              title='Similar Artists'
              description={similarArtistNames?.join(', ')}
            />
          )}
          {Boolean(countries?.length) && (
            <SettingsItem
              title='Target countries'
              description={countries?.join(', ')}
            />
          )}
        </Container>
      )}
    </>
  )
}
